import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import AdminFullTable from '../../components/AdminFullTable';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../../Styles/Admin/MicroOrganizations.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_BASE_URL from '../../config';
import '../../axios_overrite';
 
// ── Add / Edit Modal ───────────────────────────────────────
function OrganizationModal({ open, onClose, onSubmit, initialData }) {
  const [form, setForm] = useState({
    id: '', organization_name: '', address: '', contact_email: '',
    industry: '', number_of_employees: '', certification_period: '',
    certification_type: '', profile_url: ''
  });
 
  useEffect(() => {
    if (initialData) {
      setForm({
        id: initialData.id || '',
        organization_name: initialData.organization_name || '',
        address: initialData.address || '',
        contact_email: initialData.contact_email || '',
        industry: initialData.industry || '',
        number_of_employees: initialData.number_of_employees || '',
        certification_period: initialData.certification_period || '',
        certification_type: initialData.certification_type || '',
        profile_url: initialData.profile_url || ''
      });
    } else {
      setForm({ id: '', organization_name: '', address: '', contact_email: '',
        industry: '', number_of_employees: '', certification_period: '',
        certification_type: '', profile_url: '' });
    }
  }, [initialData, open]);
 
  if (!open) return null;
 
  return (
    <div className="micro-org-admin-modal-overlay">
      <div className="micro-org-admin-modal-content">
        <div className="micro-org-admin-modal-header">
          <h3>{initialData ? 'Edit Organization' : 'Add Organization'}</h3>
          <button className="micro-org-admin-modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={e => { e.preventDefault(); onSubmit(form); }}>
          <div className="micro-org-admin-modal-fields-grid">
            <div>
              <label>Organization Name
                <input type="text" value={form.organization_name} onChange={e => setForm({ ...form, organization_name: e.target.value })} required placeholder="Organization Name" />
              </label>
              <label>Contact Email
                <input type="email" value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} placeholder="Enter Email" />
              </label>
              <label>Number of Employees
                <input type="number" value={form.number_of_employees} onChange={e => setForm({ ...form, number_of_employees: e.target.value })} placeholder="Enter no. of employees" />
              </label>
              <label>Profile URL
                <input type="text" value={form.profile_url} onChange={e => setForm({ ...form, profile_url: e.target.value })} placeholder="Enter profile URL" />
              </label>
            </div>
            <div>
              <label>Address
                <input type="text" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} placeholder="Address" />
              </label>
              <label>Industry
                <input type="text" value={form.industry} onChange={e => setForm({ ...form, industry: e.target.value })} placeholder="Enter industry" />
              </label>
              <label>Certification Period
                <input type="text" value={form.certification_period} onChange={e => setForm({ ...form, certification_period: e.target.value })} placeholder="Enter certificate period" />
              </label>
              <label>Certification Category
                <select value={form.certification_type} onChange={e => setForm({ ...form, certification_type: e.target.value })} required>
                  <option value="">Select type</option>
                  <option value="Platinum ">Platinum</option>
                  <option value="Gold ">Gold</option>
                  <option value="Certified ">Certified</option>
                </select>
              </label>
            </div>
          </div>
          <div className="micro-org-admin-modal-actions">
            <button type="button" className="micro-org-admin-secondary-btn" onClick={onClose}>Cancel</button>
            <button type="submit" className="micro-org-admin-primary-btn">Confirm</button>
          </div>
        </form>
      </div>
    </div>
  );
}
 
// ── Delete Modal ───────────────────────────────────────────
function DeleteConfirmModal({ open, onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-icon">⚠️</div>
        <h2 className="delete-modal-title">Delete Information</h2>
        <div className="delete-modal-desc">This Record will be deleted</div>
        <div className="delete-modal-actions">
          <button className="delete-modal-cancel" onClick={onCancel}>No, Keep it</button>
          <button className="delete-modal-confirm" onClick={onConfirm}>Yes, Delete</button>
        </div>
      </div>
    </div>
  );
}
 
// ── Main Component ─────────────────────────────────────────
export default function CertifiedMicro() {
  const [data, setData]           = useState([]);
  const [search, setSearch]       = useState('');
  const [page, setPage]           = useState(1);
  const [total, setTotal]         = useState(0);
  const [limit, setLimit]         = useState(25);
  const [modalOpen, setModalOpen] = useState(false);
  const [editOrg, setEditOrg]     = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId]   = useState(null);
  const [exporting, setExporting] = useState(false);
 
  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, [page, search, limit]);
 
  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/micro-organizations?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`);
      setData(res.data.organizations || []);
      setTotal(res.data.total || 0);
    } catch { setData([]); setTotal(0); }
  };
 
  const handleCreate = async (org) => {
    await axios.post(`${API_BASE_URL}/api/admin/micro-organizations`, org);
    setModalOpen(false); fetchData(); toast.success('Organization added successfully!');
  };
  const handleUpdate = async (org) => {
    await axios.post(`${API_BASE_URL}/api/admin/micro-organizations/edit/${org.id}`, org);
    setModalOpen(false); setEditOrg(null); fetchData(); toast.success('Organization updated successfully!');
  };
  const handleDeleteClick   = (id) => { setDeleteId(id); setDeleteModalOpen(true); };
  const handleDeleteCancel  = ()   => { setDeleteModalOpen(false); setDeleteId(null); };
  const handleDeleteConfirm = async () => {
    await axios.post(`${API_BASE_URL}/api/admin/micro-organizations/delete/${deleteId}`);
    setDeleteModalOpen(false); setDeleteId(null); fetchData(); toast.success('Organization deleted successfully!');
  };
 
  // ── Export to a real .xlsx file (built client-side with SheetJS) ──
  const handleExport = async () => {
    setExporting(true);
    try {
      // Pull ALL matching rows (not just the current page) so the Excel file
      // reflects the full search result, same as the old CSV export did.
      const res = await axios.get(
        `${API_BASE_URL}/api/admin/micro-organizations?page=1&limit=100000&search=${encodeURIComponent(search)}`
      );
      const rows = res.data.organizations || [];
 
      if (rows.length === 0) {
        toast.info('No records to export.');
        setExporting(false);
        return;
      }
 
      // Shape the rows into clean, human-readable columns for Excel
      const excelRows = rows.map((row, index) => ({
        'ID': index + 1,
        'Organization Name': row.organization_name || '',
        'Address': row.address || '',
        'Contact Email': row.contact_email || '',
        'Industry': row.industry || '',
        'No. Of Employees': row.number_of_employees || '',
        'Certification Period': row.certification_period || '',
        'Certification Type': row.certification_type
          ? row.certification_type.replace(' Outstanding Workplaces', '')
          : '',
        'Profile URL': row.profile_url || '',
        'Status': row.status ? 'Active' : 'Inactive'
      }));
 
      const worksheet = XLSX.utils.json_to_sheet(excelRows);
 
      // Reasonable column widths so it's readable on open
      worksheet['!cols'] = [
        { wch: 6 },  { wch: 28 }, { wch: 24 }, { wch: 26 }, { wch: 18 },
        { wch: 16 }, { wch: 20 }, { wch: 18 }, { wch: 24 }, { wch: 10 }
      ];
 
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Micro Organizations');
 
      XLSX.writeFile(workbook, 'micro_organizations.xlsx');
      toast.success('Excel file downloaded!');
    } catch (err) {
      toast.error('Export failed. Please try again.');
    } finally {
      setExporting(false);
    }
  };
 
  const handleStatusToggle = async (id, currentStatus) => {
    await axios.patch(`${API_BASE_URL}/api/admin/micro-organizations/${id}/status`, { status: !currentStatus });
    fetchData(); toast.success('Status updated!');
  };
 
  const tableColumns = [
    { label: 'S.NO', key: 'id', width: 60 },
    { label: 'Organization Name', key: 'organization_name', width: 200 },
    { label: 'Address', key: 'address', width: 150 },
    { label: 'Contact Email', key: 'contact_email', width: 200 },
    { label: 'Industry', key: 'industry', width: 160 },
    { label: 'No.Of.Employee', key: 'number_of_employees', width: 130 },
    { label: 'Certification Period', key: 'certification_period', width: 180 },
    { label: 'Certification Type', key: 'certification_type', width: 160 },
    { label: 'Profile URL', key: 'profile_url', width: 160 },
    { label: 'Status', key: 'status', width: 150 },
    { label: 'Actions', key: 'actions', width: 160 }
  ];
 
  const tableData = data.map((row, index) => ({
    ...row,
    id: (page - 1) * limit + index + 1,
    certification_type: row.certification_type ? row.certification_type.replace(' Outstanding Workplaces', '') : '',
    status: (
      <div className="micro-org-admin-status-toggle">
        <span className={`micro-org-admin-status-dot${row.status ? ' active' : ''}`} />
        <span style={{ marginLeft: 4, marginRight: 6, fontSize: '0.84rem' }}>
          {row.status ? 'Active' : 'Inactive'}
        </span>
        <label className="micro-org-admin-switch">
          <input type="checkbox" checked={!!row.status} onChange={() => handleStatusToggle(row.id, row.status)} />
          <span className="micro-org-admin-slider"></span>
        </label>
      </div>
    ),
    actions: (
<div className="micro-org-admin-actions">
  <button className="micro-org-admin-edit-btn" onClick={() => { setEditOrg(row); setModalOpen(true); }}>
    <img src="/edit-filled.png" alt="edit" className="micro-org-admin-action-icon" />
  </button>
  <button className="micro-org-admin-delete-btn" onClick={() => handleDeleteClick(row.id)}>
    <img src="/delete-fill.png" alt="delete" className="micro-org-admin-action-icon" />
  </button>
</div>
    )
  }));
 
  const activeCount   = data.filter(org => org.status).length;
  const inactiveCount = data.filter(org => !org.status).length;
  const totalPages    = Math.ceil(total / limit);
  const visiblePages  = [];
  for (let i = 1; i <= totalPages && i <= 5; i++) visiblePages.push(i);
 
  return (
    <AdminLayout title="Micro Organizations" subtitle="Forms and Submissions">
      <div className="micro-org-admin-section">
        <div className="micro-org-admin-container">
 
          {/* ── Row 1: Show Entries + Add Button ── */}
          <div className="micro-org-admin-table-header">
            <div className="micro-org-admin-table-header-left">
              <div className="micro-org-admin-show-entries">
                <label htmlFor="micro-show-entries" className="micro-org-admin-show-entries-label">
                  Show Entries :
                </label>
                <select
                  id="micro-show-entries"
                  value={limit}
                  onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}
                  className="micro-org-admin-show-entries-select"
                >
                  {[10, 25, 50, 100].map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
              </div>
            </div>
            <div className="micro-org-admin-table-header-right">
              <button className="micro-org-admin-add-btn" onClick={() => { setEditOrg(null); setModalOpen(true); }}>
                + Add New Organization
              </button>
            </div>
          </div>
 
          {/* ── Row 2: Search + Stats + Export ── */}
          <div className="micro-org-admin-search-and-stats">
            <div className="micro-org-admin-search-wrapper">
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                className="micro-org-admin-table-search"
              />
              <span className="micro-org-admin-search-icon">
                <img src="/icons/search.png" alt="search" />
              </span>
            </div>
            <div className="micro-org-admin-stats-group">
              <span className="micro-org-admin-count-badge">Total Count : {total}</span>
              <span className="micro-org-admin-active-badge">Active : {activeCount}</span>
              <span className="micro-org-admin-inactive-badge">Inactive : {inactiveCount}</span>
              <button className="micro-org-admin-export-btn" onClick={handleExport} disabled={exporting}>
                <img src="/icons/excel.png" alt="Export" />
                {exporting ? 'Exporting...' : 'Export To Excel'}
              </button>
            </div>
          </div>
 
          {/* ── Table ── */}
          <div className="micro-org-admin-table-wrapper">
            <AdminFullTable
              columns={tableColumns}
              data={tableData}
              tableClass="micro-org-admin-table micro-org-admin-table-small"
            />
            <div className="micro-org-admin-table-footer">
              <div className="micro-org-admin-info">
                {total > 0
                  ? `Showing ${((page - 1) * limit) + 1} to ${Math.min(page * limit, total)} of ${total} entries`
                  : 'Showing 0 to 0 of 0 entries'}
              </div>
              <div className="micro-org-admin-pagination">
                <button disabled={page === 1} onClick={() => setPage(page - 1)} className="micro-org-admin-page-btn">‹</button>
                {visiblePages.map(pageNum => (
                  <button key={pageNum} onClick={() => setPage(pageNum)} className={`micro-org-admin-page-btn${page === pageNum ? ' active' : ''}`}>
                    {pageNum}
                  </button>
                ))}
                {totalPages > 5 && (
                  <>
                    <span className="micro-org-admin-page-btn" style={{ cursor: 'default' }}>…</span>
                    <button onClick={() => setPage(totalPages)} className={`micro-org-admin-page-btn${page === totalPages ? ' active' : ''}`}>{totalPages}</button>
                  </>
                )}
                <button disabled={page === totalPages || total === 0} onClick={() => setPage(page + 1)} className="micro-org-admin-page-btn">›</button>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <OrganizationModal open={modalOpen} onClose={() => { setModalOpen(false); setEditOrg(null); }} onSubmit={editOrg ? handleUpdate : handleCreate} initialData={editOrg} />
      <DeleteConfirmModal open={deleteModalOpen} onCancel={handleDeleteCancel} onConfirm={handleDeleteConfirm} />
      <ToastContainer position="top-right" autoClose={3000} />
    </AdminLayout>
  );
}